<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <KeyValueForm :baseKeyValue="keyValue" :basekeyValueName="name" :loading="loading" @submit-requested="submitRequested"></KeyValueForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import KeyValueForm from '@/views/KeyValues/KeyValueForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                keyValue: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { KeyValueForm },
        computed:
        {
            ...mapState('keyValues', ['getKeyValueByIdOutput']),
        },
        methods: {
            ...mapActions('keyValues', ['getKeyValueById']),
            ...mapActions('keyValues', ['putKeyValue']),
            submitRequested(keyValue) {
                this.putKeyValue(keyValue);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ path: '/keyValues/list' });
            }
            else {
                this.getKeyValueById(this.$route.query.id);
            }
        },
        watch:
        {
            getKeyValueByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({ path: '/keyValues/list' });
                }
                else {
                    this.keyValue = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>